<template>
<div class="activeUserTable">
  <v-data-table
    :page="page"
    :pageCount="pageCount"
    :server-items-length="itemCount"
  :options.sync="options"
  :headers="headers"
  :items="users"
  class="elevation-1"
  :loading="isLoading"
  loading-text="Loading Staff"
  :search="searchQuery"
>
  <template v-slot:item.select="{ item }">
    <router-link :to="{name: 'StaffInfo', params: {employeeID: item._id}}">
      <v-btn
          x-small
          class="white--text"
          color="#2b3990"

      >
          select
      </v-btn>
    </router-link>
  </template>

  <template v-slot:item.Progress="{ item }">
    <v-progress-linear
      :background-opacity="0.3"
      :buffer-value="100"
      :height="25"
      :width="150"
      :rounded="true"
      :value="item.Progress"
    >
      <div v-if="item.Progress != null" color="white">{{ item.Progress }}%</div>
      <div v-else>0%</div>

    </v-progress-linear>
  </template>

  <template v-slot:item.VerificationStatus="{ item }">
    <v-chip
      class="ma-2"
      :color="item.VerificationStatus === 'Pending' ? 'yellow' : 'green'"
      x-small
    >
      <span
        :class="item.VerificationStatus === 'Pending' ? 'black--text' : 'white--text'">
        {{ item.VerificationStatus }}
      </span>
    </v-chip>
  </template>

  <template v-slot:top>
    <v-toolbar flat color="white">
      <v-toolbar-title>Staff</v-toolbar-title>
      <v-divider class="mx-4" inset vertical></v-divider>
      <v-spacer></v-spacer>
      <v-text-field
        v-model="searchQuery"
        clearable
        flat
        solo-inverted
        hide-details
        prepend-inner-icon="search"
        label="search"
        class="desktop"
        @input="debouncedFetchData"
      ></v-text-field>
      <v-spacer></v-spacer>
      <v-btn
        v-if="isAdmin"
        color="success"
        class="mb-2 white--text mr-2"
        v-on="on"
        @click="download"
      >
        <v-icon left>mdi-download</v-icon>
          export csv
      </v-btn>
    </v-toolbar>
      <v-text-field
        v-model="searchQuery"
        clearable
        flat
        solo-inverted
        hide-details
        prepend-inner-icon="search"
        label="search"
        class="mobile ml-5 mr-5 mb-3 mt-3"
      ></v-text-field>
  </template>

  <template v-slot:item.actions="{ item }">
    <v-icon
      small
      class="mr-2"
      @click="viewEmployee(item)"
      v-if="Role === 'Administration' || Role === 'SuperAdministrator'"
    >
        mdi-eye
    </v-icon>
    <v-icon
      small
      class="mr-2"
      @click="changePassword(item)"
      v-if="Role === 'Administration' || Role === 'SuperAdministrator'"
    >
      mdi-account-key
    </v-icon>
  </template>
  <template v-slot:no-data>
    <v-btn color="#2b3990" class="white--text" @click="getEmployees()">Reset</v-btn>
  </template>
  <template v-slot:item.Name="{ item }">
    <span :class="getUserClass(item)">
      {{ item.Name }}
    </span>
  </template>
</v-data-table>
<EditDialog :dialogVisible="editdialog" @closeDialog="closeDialog" :programs="programs" :selectedItem="selectedItem"  />
<PasswordDialog :dialogVisible="passdialog" @closeDialog="closeDialog" :employeeID="employeeID"  />
</div>
</template>

<script>

import axios from 'axios'
import { mapActions, mapState } from "vuex";
import moment from 'moment'
import Swal from 'sweetalert2'

import EditDialog from "./dialog/edit.vue"
import PasswordDialog from "./dialog/password.vue"
import debounce from 'lodash/debounce';

const url = require("../../client_config/config").url;

export default{
props: {
  programs: {
    type: Array,
    required: true
  },
  employeeRole: {
    type: String,
    required: true
  },
  isAdmin:{
    type: Boolean,
    required: true
  }
},
components: {
  EditDialog,
  PasswordDialog
},
data: function () {
  return {
    headers: [
      {
        text: 'Select Staff',
        align: 'start',
        sortable: false,
        value: 'select',
      },
      {text: "Name", value: "Name"},
      {text: "Phone", value: "PhoneNumber"},
      {text: "Email", value: "Email"},
      {text: "State", value: "State"},
      {text: "Position", value: "Role"},
      {text: "Status", value: "Status"},
      {text: "Program", value: "programDisplay"},
      {text: "Progress", value: "Progress"},
      {text: "Verification Status", value: "VerificationStatus"},
      {text: "Actions", value: "actions", sortable: false},
    ],
    employeeID: "",
    date: null,
    editdialog: false,
    passdialog: false,
    editEmail: false,
    editEmployee: false,
    msg: false,
    search: "",
    searchQuery: "",
    text: "",
    newName: "",
    newPassword: "",
    newRePass: "",
    position: ["Admin", "House Manager", "Assistant Manager", "Direct Care Staff"],
    estatus: ["Full-Time", "Part-Time"],
    page: 1,
    pageCount: 1,
    itemCount: 0,
    options: {},
      Role: localStorage.getItem('userRole'),
      userState: localStorage.getItem('userState'),
      isLoading: true,
      requiredField: [
          v => !!v || 'This is required',
      ],
      emailRules: [
          v => !!v || 'This is required',
          v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
      ],
      users: [],
      selectedItem: {},
      on: false
    };
  },

  computed: {
    ...mapState({
        droles: 'userRoles',
    }),

    formTitle() {
        return this.editedIndex != 1 ? "New Item" : "Edit Item";
    },
    queryParams(){
      const companyIds = localStorage.getItem('userCompanies');
      let {page, itemsPerPage, sortBy, sortDesc} = this.options;
      const sortField = sortBy ? sortBy[0] : 'Name';
      const sortDirection = sortDesc ? (sortDesc[0] ? 1:-1) : 1;

      page = page || 1;
      itemsPerPage = itemsPerPage || 10;

      let params = {
        page: page,
        limit: itemsPerPage,
        companyIds: companyIds,
        status:'active',
        search: this.searchQuery,
        sortField: sortField,
        sortDirection: sortDirection,
      };

      if (this.employeeRole === "AdminState") {
        params.state = this.userState;
      }

      if (this.employeeRole === "SuperAdmin") {
        params.companyIds = 'All';
      }
      return params
    }

  },

  watch: {
    options: {
      handler() {
        this.getEmployees();
      },
      deep: true
    },

    searchQuery: 'debouncedFetchData',
  },

  async created() {

  },

  methods: {

    ...mapActions({
            downloadCSV: "users/downloadCSV",
        }),

    initialize() {
        this.employees = [];
    },

    validate() {
      return this.$refs.form.validate()
    },

    debouncedFetchData: debounce(function () {
      this.options.page = 1; // Reset to the first page on new search
      this.getEmployees();
    }, 1000),

    async getEmployees() {
      this.isLoading = true;
      axios.get(`${url}/employees/company/pagination`, { params: this.queryParams}).then(res => {
          this.users = res.data.UsersResult.map(item => ({  
            ...item,
            programDisplay: item.Program?.length
              ? item.Program.filter(p => p?.trim()).join(', ')
              : 'N/A',    
            }));
          this.itemCount = res.data.totalCount;
        }).finally(() => {
          this.isLoading = false;
        });

      if(this.employeeRole === "AdminState") {
        this.headers = [
          {
              text: 'Select Staff',
              align: 'start',
              sortable: false,
              value: 'select',
          },
          {text: "Name", value: "Name"},
          {text: "Phone", value: "PhoneNumber"},
          {text: "Email", value: "Email"},
          {text: "State", value: "State"},
          {text: "Position", value: "Role"},
          {text: "Status", value: "Status"},
          {text: "Program", value: "programDisplay"}
        ];
      }
    },

    viewEmployee(item) {
      this.titleForm = "Viewing " + item.Name;
      this.editEmail = true
      this.editdialog = true;
      this.editEmployee = true;
      this.selectedItem = item;
    },

    close() {
        this.editdialog = false;
        this.passdialog = false;
        this.$nextTick(() => {
            this.editedItem = Object.assign({}, this.defaultItem);
            this.editedIndex = -1;
        });
    },

    closeDialog(){
      this.editdialog = false;
      this.passdialog = false;
      this.selectedItem = {};
      this.employeeID = "";
      this.getEmployees();
    },

    changePassword(item) {
      this.passdialog = true;
      this.employeeID = item._id;
    },

    async download() {
      Swal.fire({
        title: 'Please wait...',
        text: 'Downloading csv...',
        icon: 'info',
        allowOutsideClick: true,
        showConfirmButton: false,
        willOpen: () => {
          Swal.showLoading();
        },
      });
      try {
          const response = await this.downloadCSV(this.userState)
          if (response.success) {
              var FileSaver = require("file-saver");
              const blob = new Blob([response.data], {type: "text/csv"});
              FileSaver.saveAs(blob, response.filename);
              Swal.fire({
                icon: 'success',
                title: 'Success',
                text: "Downloading CSV is Completed.",
              })
              return
          }

      } catch (error) {
          console.log(error)
           Swal.fire({
            icon: 'error',
            title: 'Error',
            text: "Error upon downloading CSV.",
          })
      }
    },

    checkDate(date) {
      let isDateValid = isNaN(Date.parse(date))
      if (isDateValid) {
          return date = ""
      }
      return moment(date).format('YYYY-MM-DD')
    },

    getUserClass(user) {
      return user.RequiresSupervision ? 'red-header' : '';
    }

  },

  mounted() {
    this.getEmployees();
  },
}
</script>
